module.exports = __webpack_public_path__ + "img/EconomyTechBackgroundC02_ua.e22a1b48.webp";